/**
 * ============================================================================
 * GENERATED FILE - Created via: pnpm run generate:wetags
 * ============================================================================
 *
 * This file was generated by the wetag library generator.
 *
 * To add new entity types or update configuration, run:
 *   pnpm run generate:wetags
 *
 * You can safely modify this file if needed, but using the generator
 * ensures consistency across all wetag libraries in the codebase.
 *
 * To add type-safe tag names, update the tags.ts file in this directory.
 * ============================================================================
 */

/**
 * @deprecated
 *
 * Note: The goal of Wetags is to have one team per namespace.
 * So we need to create all new payments wetags under the payments namespace.
 *
 * The weave-location tags can go away when phased out.
 */
import { createNamespacedWetagHooksForOrg, createWetagHooksForPropDriven } from '@frontend/wetags';
import type { PaymentsDeprecatedTags } from './tags';

const PAYMENTS_DEPRECATED_NAMESPACE = 'weave-location';

export const PaymentsDeprecatedOrg =
  createNamespacedWetagHooksForOrg<PaymentsDeprecatedTags>(PAYMENTS_DEPRECATED_NAMESPACE);
export const PaymentsDeprecatedProp =
  createWetagHooksForPropDriven<PaymentsDeprecatedTags>(PAYMENTS_DEPRECATED_NAMESPACE);
